// modals/banners/EditBannerModal.js
import React from "react";
import { Modal, Button, Form } from "react-bootstrap";

const EditBannerModal = ({ show, onHide, onUpdate, newBanner, handleChange, handleFileChange }) => {
  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>Modifier le Slide</Modal.Title>
      </Modal.Header>
      <Form onSubmit={(e) => { e.preventDefault(); onUpdate(); }}>
        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Label>Titre (optionnel)</Form.Label>
            <Form.Control
              type="text"
              name="title"
              value={newBanner.title}
              onChange={handleChange}
              placeholder="Ex: Événement spécial"
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Légende *</Form.Label>
            <Form.Control
              as="textarea"
              rows={2}
              name="caption"
              value={newBanner.caption}
              onChange={handleChange}
              required
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Lien cible</Form.Label>
            <Form.Control
              type="url"
              name="linkUrl"
              value={newBanner.linkUrl}
              onChange={handleChange}
              placeholder="https://yoursite.com/..."
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Type</Form.Label>
            <Form.Select name="type" value={newBanner.type} onChange={handleChange}>
              <option value="home-slider">Carrousel d'accueil</option>
              <option value="promo-banner">Bannière promo</option>
              <option value="flash-sale">Flash Sale</option>
            </Form.Select>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Date de début *</Form.Label>
            <Form.Control
              type="date"
              name="startDate"
              value={newBanner.startDate}
              onChange={handleChange}
              required
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Date de fin *</Form.Label>
            <Form.Control
              type="date"
              name="endDate"
              value={newBanner.endDate}
              onChange={handleChange}
              required
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Changer l'image ?</Form.Label>
            <Form.Control
              type="file"
              accept="image/*"
              onChange={handleFileChange}
            />
            <small className="text-muted">Laissez vide pour conserver l’image actuelle</small>

            {
              newBanner.imageUrl && (
                <div className="mt-3">
                  <img src={newBanner.imageUrl} alt="Preview" style={{ maxHeight: '150px' }} />
                </div>
              )
            }

          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Ordre d'affichage</Form.Label>
            <Form.Control
              type="number"
              name="sortOrder"
              value={newBanner.sortOrder}
              onChange={handleChange}
              min="0"
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onHide}>
            Annuler
          </Button>
          <Button variant="success" type="submit">
            Enregistrer
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default EditBannerModal;